import { LAUNCH_PAD_UNAVAILABLE_HINT } from "@/components/launch_pad/launchPadConfig";
import { cn } from "@/lib/utils";

type LaunchPadUnavailableHintProps = {
  hint?: string;
  className?: string;
};

/** Overlays the card on hover/focus — no layout gap when idle. */
export function LaunchPadUnavailableHint({
  hint = LAUNCH_PAD_UNAVAILABLE_HINT,
  className,
}: LaunchPadUnavailableHintProps) {
  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-x-0 bottom-0 z-10 px-4 pb-3 pt-10",
        "bg-gradient-to-t from-card from-40% via-card/90 to-transparent",
        className,
      )}
    >
      <p className="text-xs leading-snug text-muted-foreground">{hint}</p>
    </div>
  );
}
